import {
  FaSun,
  FaCloudSun,
  FaCloud,
  FaSmog,
  FaCloudShowersHeavy,
  FaCloudRain,
  FaSnowflake,
  FaBolt,
  FaCheckCircle,
  FaBell,
  FaTemperatureHigh,
} from "react-icons/fa";
import { Trans } from "@lingui/react/macro";

export const weatherCodeToIcon: Record<number, React.ElementType> = {
  0: FaSun, // Clear sky
  1: FaCloudSun, // Mainly clear
  2: FaCloudSun, // Partly cloudy
  3: FaCloud, // Overcast
  45: FaSmog, // Fog
  48: FaSmog, // Depositing rime fog
  51: FaCloudShowersHeavy, // Light drizzle
  53: FaCloudShowersHeavy, // Moderate drizzle
  55: FaCloudShowersHeavy, // Dense drizzle
  56: FaCloudRain, // Light freezing drizzle
  57: FaCloudRain, // Dense freezing drizzle
  61: FaCloudRain, // Slight rain
  63: FaCloudRain, // Moderate rain
  65: FaCloudRain, // Heavy rain
  66: FaCloudRain, // Light freezing rain
  67: FaCloudRain, // Heavy freezing rain
  71: FaSnowflake, // Slight snow fall
  73: FaSnowflake, // Moderate snow fall
  75: FaSnowflake, // Heavy snow fall
  77: FaSnowflake, // Snow grains
  80: FaCloudShowersHeavy, // Slight rain showers
  81: FaCloudShowersHeavy, // Moderate rain showers
  82: FaCloudShowersHeavy, // Violent rain showers
  85: FaSnowflake, // Slight snow showers
  86: FaSnowflake, // Heavy snow showers
  95: FaBolt, // Thunderstorm
  96: FaBolt, // Thunderstorm with slight hail
  99: FaBolt, // Thunderstorm with heavy hail
};

export function weatherDescription(code?: number): React.ReactNode {
  switch (code) {
    case 0:
      return <Trans>Clear sky</Trans>;
    case 1:
      return <Trans>Mainly clear</Trans>;
    case 2:
      return <Trans>Partly cloudy</Trans>;
    case 3:
      return <Trans>Overcast</Trans>;
    case 45:
      return <Trans>Fog</Trans>;
    case 48:
      return <Trans>Depositing rime fog</Trans>;
    case 51:
      return <Trans>Light drizzle</Trans>;
    case 53:
      return <Trans>Moderate drizzle</Trans>;
    case 55:
      return <Trans>Dense drizzle</Trans>;
    case 56:
      return <Trans>Light freezing drizzle</Trans>;
    case 57:
      return <Trans>Dense freezing drizzle</Trans>;
    case 61:
      return <Trans>Slight rain</Trans>;
    case 63:
      return <Trans>Moderate rain</Trans>;
    case 65:
      return <Trans>Heavy rain</Trans>;
    case 66:
      return <Trans>Light freezing rain</Trans>;
    case 67:
      return <Trans>Heavy freezing rain</Trans>;
    case 71:
      return <Trans>Slight snow fall</Trans>;
    case 73:
      return <Trans>Moderate snow fall</Trans>;
    case 75:
      return <Trans>Heavy snow fall</Trans>;
    case 77:
      return <Trans>Snow grains</Trans>;
    case 80:
      return <Trans>Slight rain showers</Trans>;
    case 81:
      return <Trans>Moderate rain showers</Trans>;
    case 82:
      return <Trans>Violent rain showers</Trans>;
    case 85:
      return <Trans>Slight snow showers</Trans>;
    case 86:
      return <Trans>Heavy snow showers</Trans>;
    case 95:
      return <Trans>Thunderstorm</Trans>;
    case 96:
      return <Trans>Thunderstorm with slight hail</Trans>;
    case 99:
      return <Trans>Thunderstorm with heavy hail</Trans>;
    default:
      return <Trans>Unknown</Trans>;
  }
}
